export default __webpack_public_path__ + "static/logo-small-a98eb81b6a55c46f93cdd351ec810c93.jpg";